/* eslint-disable prettier/prettier */
export default {
  'sign-in': 'Log in',
  'sign-in-1': 'Log in',
  'sign-in.immediately': 'Log in',
  'sign-in.success': 'Log in Success',
  'sign-up': 'Sign up',

  'sign-up.immediately': 'Sign Up',
  'sign-up.success': 'Sign up Success',
  'logout.success': 'Signed out',

  'order': 'Order',
  'delegate-total': 'Total',
  'address': 'Address',
  'asset': 'Asset',
  'asset.deposit': 'Deposit',
  'asset.deposit.address': 'Deposit Address',
  'asset.deposit.tip':
    'It is forbidden to deposit {coin} address with assets other than {coin}, and any non-{coin} assets charged with {coin} address will not be retrieved.\n deposit with {coin} address requires {min_confirmation} network confirmation to reach the account \n recharging with minimum amount {min_amount} {coin}, less than {min_amount} {coin} will not be able to reach the account',
  'asset.deposit.labeltip':
    'It is forbidden to deposit {coin} address with assets other than {coin}, and any non-{coin} assets charged with {coin} address will not be retrieved.\n deposit with {coin} address requires {min_confirmation} network confirmation to reach the account \n recharging with minimum amount {min_amount} {coin}, less than {min_amount} {coin} will not be able to reach the account \n deposit with {coin} at the same time requires a recharging address and {coin} label.Warning: if you do not follow the correct {coin} recharge steps, COINS will be lost!',
  'asset.deposit.title': 'Deposit Crypto',

  'asset.withdraw': 'Withdraw',
  'asset.withdraw_title': 'Withdraw Crypto',

  'asset.white-paper': 'White Paper',

  'withdraw.modal.save': 'Save the address',
  'withdraw.modal.title2': 'Withdrawal request is sent',
  'withdraw.modal.network': 'Network',

  'unit': 'Unit',
  'user.center': 'User Center',
  'user.security': 'Security Center',
  'user.logout': 'Log out',

  'certificate.front': 'ID photo on the front',
  'certificate.inhand.pic': 'Photo ID and declaration',
  'certificate.upload.tip': '{type}: Please wait for successful upload before submitting!',

  'and': 'And',
  'inhand': 'Hand',
  'pair': 'Pair',
  'last-price': 'Last Price',
  '24h-vol': '24h Vol',
  'max-price': 'High',
  'min-price': 'Low',
  'change': 'Change',
  'coin': 'Coin',
  'fiat': 'Fiat',
  
  'price': 'Price',
  'size': 'Size',
  'total': 'Total',
  'time': 'Time',
  'time.start': 'Start Time',
  'time.end': 'End Time',
  'amount': 'Amount',

  'balance': 'Balance',
  'balance.avail': 'Available',
  'balance.other-frozen': 'Other Frozen',
  'exchange.limit': 'Limit',
  'exchange.market': 'Market',

  'buy': 'Buy',
  'buy-1': 'Buy',
  'sell': 'Sell',
  'sell-1': 'Sell',
  'sign-in-or-up': 'Log in or Sign up',
  'open-order': 'Open Order',
  'order-history': 'Order History',
  'order.cancel': 'Cancel',
  'date': 'Date',
  'type': 'Type',
  'executed': 'Completed',
  'unexecuted': 'Pending',
  'action': 'Action',
  'average': 'Average',
  'avg-price': 'Avg. price',
  'status': 'Status', 
  'checking': 'Under review', 
  'checked.once': 'First review passed',
  'processing': 'Pending for verification',
  'success': 'Completed',
  'failed': 'Failure',
  'completed': 'Filled',
  'completed-1': 'Completed',
  'sent': 'Sent',
  'confirmation': 'Confirming...',
  'buying': 'Partial filled',
  'canceled': 'Canceled',
  'cancel': 'Cancel',
  'cancel-1': 'Cancel',
  'cancel.success': 'Cancelled successfully',
  'commission': 'Fee',
  
  'password': 'Password',
  'password.old': 'Old Password',
  'password.new': 'New Password',
  'password.forget': 'Forgot Password',
  'password.confirm': 'Confirm Password',
  'password.confirm.error': 'The two Passwords You Entered Did not Match',
  'password.tip': '6-16 Digits or Letters',
  'password.reset': 'Reset Password',
  'password.reset.success': 'Password Reset Success',
  'password.fund': 'Fund Password',
  'password.fund.unset.tip': 'The Fund Password Is not set, Please Go To Settings',
  
  'account': 'Account',
  'required': 'Required',
  'submit': 'Submit',
  'submitted': ' submission complete',
  'home': 'Home',
  'business': 'Business',
  'modify': 'Modify',
  'edit.success': 'Edit successfully',
  'create': 'Create',
  'bind': 'Bind',
  'set': 'Set',
  'reset': 'Reset',
  'beenSet': 'Been Set',
  'beenReset': 'Been Reset',
  'recommend.code': 'Referral Code',
  'recommend.code.tip': 'Referral Code',

  'verify.security': 'Security Verification',
  'verify.code': 'Verification code',
  'verify.code.phone': 'Phone verification code',
  'verify.code.email': 'Email verification code',
  'verify.code.google': 'Google Verification Code',
  'verify.code.get': 'Get the code',
  'verify.code.get.success': 'Verification code has been sent, please use it within 5 minutes',
  'verify.close.success': 'Disable verification successfully',
  'verify.open.success': 'Enable verification successful',
  'verify.google': 'Google Authenticator',
  
  'download': 'Download',
  'phone': 'Phone',
  'email': 'Email',

  'security': 'Security',
  'security.passwords.fund': 'Set Fund Password',
  'security.bind.email': 'Bind Email',
  'security.bind.phone': 'Bind Phone Number',

  'edit': 'Edit',
  'create_success': 'Created Successfully',
  'day': 'day',
  'hour': 'hour',
  'high': 'High',
  'middle': 'Middle',
  'low': 'Low',
  'secretKey': 'Key',
  'details': 'Details',
  'copy': 'Copy',
  'copy.success': 'Copy Success',
  'copy.failed': 'Copy Failed',
  'add': 'Add',
  'add.success': 'Add Success',
  'del': 'Delete',
  'del.success': 'Delete Success',
  'remark': 'Remark',
  'nation': 'Nationality',
  'nation.Please': 'Please select the country or region',
  'name': 'Name',
  'name.family': 'Last Name',
  'name.first': 'First Name',
  'idCard': 'ID Number',
  'next': 'Next',
  'pre': 'Pre',
  'unauthorized': 'Verify your account',
  'unauthorized.tip': 'You have not completed the personal certification',
  'authorized': 'Approved',
  'authorize': 'Authorize',
  'authorize.failed': 'Authorize Failed',

  'all': 'All',
  'phone.belongs': 'Location',
  'sure': 'Sure To',
  'ma': '?',
  'tips': 'Tips',
  'tip': 'Tips',
  'bank': 'Bank',
  'bank.card': 'Bank Card',
  'transfer': 'Transfer',
  'info': 'Info',

  'minute': 'Minute',
  'expired': 'Expired',
  'agree': 'Agree',
  'view': 'View',
  'validate.pwd.error': 'Password format error',

  'attachment': 'Attachment',
  'img': 'Image',
  'img.upload.success': 'Img Upload Success',
  'token.expire': 'Authorization is Expired! Please Log in Again',  
  'more': 'More',
  'format': 'Format',
  'join': 'Join',
  'activity': 'Activity',
  'fast': 'Fast',
  'service': 'Service',
  'recommend': 'Recommend',
  'coming-soon': 'Coming Soon',
  'result_no_record': 'No Data',
  'result_no_found': 'No results found.',
  'memo': 'Memo',
  'title': 'Title',
  'content': 'Content',
  'feedback': 'Feedback',
  'createdAt': 'created time',
  'new': 'New',
  'me': 'Me',
  'other': 'Other',
  'back': 'Back',
  'select': 'Select',
  'c2c': 'C2C',

  'history': 'History',

  'password.length_tip': '{num1}-{num2} Characters',
  'At least one lowercase letter': 'At least one lowercase letter',
  'At least one uppercase letter': 'At least one uppercase letter',
  'At least one number': 'At least one number',
  'At least one special symbol': 'At least one special symbol',
  'Special symbols include': 'Special symbols include',

  'Close': 'Close',
  'country_unavailable_tip': 'Biconomy.com is unavailable in your country or region. We apologize for the inconvenience.',
  'spot_trading': 'Spot Trading',
  'state': 'State',
  "Currency": "Currency"
};
